import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { WorkstationSummaryDto } from "~/types/api";

export type NetworkLog = {
  timestamp: string;
  duration: number;
  error?: string;
  request: {
    startTime: number;
    method: string;
    url: string;
    body?: unknown;
  };
  response?: {
    statusCode?: number;
    body?: unknown;
  };
};

export type SupportBundle = {
  timestamp: string;
  url: string;
  userAgent: string;
  user: {
    profileName: string | null;
    siteFulfillmentCenterId: string | null;
    clientId: string | null;
    workstation: WorkstationSummaryDto | null;
  };
  sentry?: {
    sessionId?: string;
    replayId?: string;
    traceId?: string;
    environment?: string;
    timestamp?: number;
    started?: number;
    duration?: number;
    status?: string;
    release?: string;
  };
  screenshot?: string | null;
  networkLogs: NetworkLog[];
};

export type State = {
  isLoggingEnabled: boolean;
  networkLogs: NetworkLog[];
};

const initialState: State = {
  isLoggingEnabled: false,
  networkLogs: []
};

export const supportBundleSlice = createSlice({
  name: "supportBundle",
  initialState,
  reducers: {
    setIsLoggingEnabled: (state, action: PayloadAction<boolean>) => {
      state.isLoggingEnabled = action.payload;
    },
    addNetworkLog: (state, action: PayloadAction<NetworkLog>) => {
      state.networkLogs.push(action.payload);
      // Remove old logs periodically
      if (state.networkLogs.length > 300) {
        state.networkLogs = state.networkLogs.slice(-200);
      }
    }
  },
  selectors: {
    selectNetworkLogs: (state) => state.networkLogs
  }
});

export const { addNetworkLog, setIsLoggingEnabled } =
  supportBundleSlice.actions;

export const { selectNetworkLogs } = supportBundleSlice.selectors;
